import { render, staticRenderFns } from "./PchPurchaseOrderDetail.vue?vue&type=template&id=4c495eae&lang=pug&"
import script from "./PchPurchaseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PchPurchaseOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchPurchaseOrderDetail.vue"
export default component.exports